// src/components/SelectedCapsuleOverlay.js
import React from 'react';
import { Box, IconButton, Typography, Button } from '@mui/material';

export default function SelectedCapsuleOverlay({
    capsule,
    travelTime,
    onWalkClick,
    onViewDetails,
    onClose,
}) {
    const isNavigating = Boolean(travelTime);

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                bgcolor: 'white',
                zIndex: 10000,
                p: 2,
            }}
        >
            <Box sx={{ textAlign: 'right' }}>
                <IconButton size="small" onClick={onClose} sx={{ p: 0 }}>
                    ✕
                </IconButton>
            </Box>

            {capsule.imageUrl && (
                <Box
                    component="img"
                    src={capsule.imageUrl}
                    alt=""
                    sx={{
                        width: '100%',
                        height: 140,
                        objectFit: 'cover',
                        borderRadius: 1,
                        mb: 1,
                    }}
                />
            )}

            <Typography variant="h6" gutterBottom>
                {capsule.title}
            </Typography>
            <Typography variant="body2" paragraph>
                {capsule.snippet}
            </Typography>

            {travelTime && (
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                    Estimated walk: {travelTime}
                </Typography>
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    size="small"
                    variant="outlined"
                    onClick={isNavigating ? onClose : onWalkClick}
                    sx={{
                        borderRadius: '50px',
                        textTransform: 'none',
                        padding: '4px 20px',
                        boxShadow: 'none',
                        '&:hover': { boxShadow: 'none' },
                    }}
                >
                    {isNavigating ? 'Cancel Walk' : 'Walk Here'}
                </Button>
                <Button
                    size="small"
                    variant="contained"
                    onClick={onViewDetails}
                    sx={{
                        borderRadius: '50px',
                        textTransform: 'none',
                        padding: '4px 20px',
                        boxShadow: 'none',
                        '&:hover': { boxShadow: 'none' },
                    }}
                >
                    View Details
                </Button>
            </Box>
        </Box>
    );
}
